import React from 'react';

import extendGlobalDialogAction from '@glass/web/modules/globalDialog/extendGlobalDialogAction';
import openGlobalDialogAction from '@glass/web/modules/globalDialog/openGlobalDialogAction';
import resetGlobalDialogAction from '@glass/web/modules/globalDialog/resetGlobalDialogAction';

import LazyBaseDialog from '@glass/shared/components/Dialog/LazyBaseDialog';

const CONFIRM_REASON = 'confirm';
const CANCEL_REASON = 'cancel';
const CLOSE_REASON = 'close';

const openConfirmationDialogAction =
  ({
    onClose,
    onCancel,
    onConfirm,
    title,
    message,
    confirmText,
    cancelText,
    cancelVariant,
    cancelColor,
    cancelFullWidth,
  }) =>
  (dispatch) =>
    new Promise((resolve) => {
      const handleClose = async (evt, reason = CLOSE_REASON) => {
        if (typeof onClose === 'function') {
          await Promise.resolve(onClose(reason));
        }
        dispatch(resetGlobalDialogAction());
        resolve(reason);
      };

      const handleConfirm = async (evt) => {
        if (typeof onConfirm === 'function') {
          dispatch(extendGlobalDialogAction({ confirmLoading: true }));
          await Promise.resolve(onConfirm());
        }
        return handleClose(evt, CONFIRM_REASON);
      };

      const handleCancel = async (evt) => {
        if (typeof onCancel === 'function') {
          await Promise.resolve(onCancel());
        }
        return handleClose(evt, CANCEL_REASON);
      };

      return dispatch(
        openGlobalDialogAction({
          title,
          message,
          confirmText,
          onClose: handleClose,
          children: (
            <LazyBaseDialog
              cancelColor={cancelColor}
              cancelFullWidth={cancelFullWidth}
              cancelText={cancelText}
              cancelVariant={cancelVariant}
              confirmText={confirmText}
              message={message}
              title={title}
              onCancel={handleCancel}
              onConfirm={handleConfirm}
            />
          ),
        }),
      );
    });

export default openConfirmationDialogAction;
